import { ADMIN_URL } from 'shared/config';

export const getLinkForExternalFeedbackForm = (id: string | number) => `${ADMIN_URL}/talents/soft-skill/generate-url/${id}`;
